<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'FeeHistory',
  }
</script>

<style scoped>
</style>